<template>
    <div class="max-w-[700px] mx-auto">
        <hts-form
            class="w-full"
            :rules="rules"
            @submit="handleSubmit">
            <hts-card class="pt-2">
                <hts-form-input
                    v-model="dataCost.monthlyInterest"
                    :label="$t('labels.monthlyInterestPercent')"
                    type="number"
                    required
                    name="monthlyInterestPercent"
                    prop="monthlyInterestPercent" />
                <hts-form-input
                    v-model="dataCost.corporateIncomeTax"
                    :label="$t('labels.corporateIncomeTaxPercent')"
                    required
                    type="number"
                    name="corporateIncomeTaxPercent"
                    prop="corporateIncomeTaxPercent" />
                <hts-form-input
                    v-model="dataCost.incrementLevel"
                    required
                    :label="$t('labels.incrementLevelPercent')"
                    type="number"
                    name="incrementLevelPercent"
                    prop="incrementLevelPercent" />

                <div>
                    <hts-form-button
                        icon-name="hi-clipboard-document-check-icon"
                        icon-position="right"
                        color="primary"
                        type="submit">
                        {{ $t('labels.save') }}
                    </hts-form-button>
                </div>
            </hts-card>
        </hts-form>
    </div>
</template>

<script lang="ts" setup>
import { IGlobalSettingCost } from './ignore/imports/form'
const emits = defineEmits(['updateData'])
const { $disableReactive } = useNuxtApp()

const dataCost = ref<IGlobalSettingCost>({
  monthlyInterest: null,
  corporateIncomeTax: null,
  incrementLevel: null
})
const props = defineProps({
  globalSettingsInformation: {
    type: Object,
    default: () => {}
  }
})
const { globalSettingsInformation } = toRefs(props)

const store = $store()

const handleSubmit = () => {
  const api = $urlClient.settings.updateCostSettings
  $api(api, { body: { cost: dataCost.value } })
    .then((data) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (responseData.success) {
        store.globalSettings.setGlobalSettings(responseData.data)
        emits('updateData')
        process.client && $toast().success($t('notifications.updateSuccess'))
      }
    })
    .catch(() => {
      process.client && $toast().error($t('notifications.updateError'))
    })
}
onMounted(() => {
  Object.assign(dataCost.value, $disableReactive(globalSettingsInformation.value.cost))
})

const rules = {
  monthlyInterestPercent: 'required',
  corporateIncomeTaxPercent: 'required',
  incrementLevelPercent: 'required'
}
</script>

<style scoped></style>
